import React from 'react';
import { calculatePrice } from './utils';

class OverviewSection extends React.Component {

    calculatePrice = () => {
        let { reservation, reservationLength, app } = this.props;
        return calculatePrice(reservation, reservationLength, app);
    }

    render() {
        let { reservation, app } = this.props;
        const isCamping = app.state.activeCalendar?.type === 'accommodation';
        
        let kanoeCount = parseInt(reservation.kanoe_count) || 0;
        if (kanoeCount === 0) {
            kanoeCount = parseInt(reservation.kanoe_count_info_max) || 0;
        }
        
        let isInformationOnly = reservation.kanoe_count === 0;
        let canoePrice = this.calculatePrice();

        if (this.props.returnPriceOnly) {
            return canoePrice;
        }

        return (
            <div className="flex items-center justify-between py-2.5">
                <div className="flex items-center gap-3">
                    <div className={`w-2 h-2 rounded-full ${isCamping ? 'bg-taborisko-orange' : 'bg-splavma-orange'}`}></div>
                    <span className="text-sm font-medium text-gray-700">
                        Prenájom lodí ({kanoeCount}ks)
                    </span>
                </div>
                <span className="text-sm font-bold text-gray-900">
                    {isInformationOnly ? 'ℹ ' : ''}{canoePrice.toFixed(2)}&nbsp;€
                </span>
            </div>
        );
    }
}

export default OverviewSection;
